import { Button, SpinnerCircular } from "@weirgroup/weir-dls";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { GroupFormField } from "./input-fields";
import { useTranslation } from "react-i18next";
import assetApi from '../../../api/assets.api';
import { useDateConverter } from "../../../hooks/use-date-converter";
import { BucketDataType, TagType, UpdateAssetDataType } from "../../../types/bucketTypes";
import { getPermission, isReadOnly } from "../../../utils/roles.util";
import { useDarkMode } from "../../../hooks/use-darkmode";
interface Props {
  selectedAsset: BucketDataType
  tagData: TagType | undefined
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
  setSelectedAsset: Dispatch<SetStateAction<any>>;
  setIsAssetUpdated: Dispatch<SetStateAction<boolean>>
  isGuest: boolean
}

export const AssetOverview = (props: Props) => {
  const {
    selectedAsset,
    tagData,
    isLoading,
    setIsLoading,
    setSelectedAsset,
    setIsAssetUpdated,
    isGuest
  } = props;
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const { convertDateStringToFormat } = useDateConverter();
  const { t } = useTranslation();
  const {
    stock_number,
    attachment_type,
    model,
    capacity,
    manufacturer,
    machine_number,
    make,
    lip_width
  } = selectedAsset;

  const listA = {
    stock_number,
    attachment_type,
    model,
    capacity,
    manufacturer
  }

  const listB = {
    machine_number,
    make,
    class: selectedAsset.class,
    lip_width,
    last_scan: convertDateStringToFormat(tagData?.location?.created_at ?? "")
  }

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [stockNumberValue, setStockNumberValue] = useState<string>("");
  const [machineNumberValue, setMachineNumberValue] = useState<string>("");
  const {darkMode} = useDarkMode();
  useEffect(() => {
    const roles = sessionStorage.getItem('roles');
    const permissions = getPermission(roles)
    setIsDisabled(isReadOnly(permissions));
  })

  const toggleIsEditing = () => {
    setIsEditing(!isEditing);
  }

  const saveAssetInfo = async () => {
    setIsEditing(!isEditing);
    setIsLoading(true);
    const updatedData: UpdateAssetDataType = {
      "asset_id": selectedAsset.asset_id.toString(),
      ...(machineNumberValue ? { "machine_number": machineNumberValue } : {}),
      ...(stockNumberValue ? { "stock_number": stockNumberValue } : {})
    }
    assetApi.updateAsset(updatedData).then((updatedAsset: any) => {
      setSelectedAsset(updatedAsset.data.data)
      setIsLoading(false);
      setIsEditing(false);
      setIsAssetUpdated(true)
    }).catch((error: any) => {
      console.error(error);
      setIsEditing(false);
      setIsLoading(false);
      setIsAssetUpdated(true)
    });
  }

  return (
    <div className="asset-overview" data-testid="asset-overview">
      {isLoading ?
        <div className="spinner">
          <SpinnerCircular darkMode={darkMode} />
          <p>{t("loading").toString()}</p>
        </div> : <></>}
      <div className="tag-id-container">
        <p className="tag-id" style={{color:darkMode ? "white" : "rgb(105, 118, 128)"}}><strong>{t("tagID")}:</strong></p><p className="tag-id-value" style={{color:darkMode ? "white" : "black"}}>{tagData?.esn}</p>
      </div>
      <div className="flex-container ">
        <div className="flex-item">
          <GroupFormField
            list={listA}
            isEditing={isEditing}
            setStockNumberValue={setStockNumberValue}
          />
        </div>
        <div className="flex-item">
          <GroupFormField
            list={(listB)}
            isEditing={isEditing}
            setMachineNumberValue={setMachineNumberValue}
          />
        </div>
      </div>
      <div data-testid="buttons">
        {isEditing ?
          <div className="buttons" >
            <Button
              darkMode={darkMode}
              className="cancel-btn"
              label={"Cancel"}
              size={"sm"}
              variant={"secondary"}
              disabled={isDisabled}
              onClick={toggleIsEditing}
            />
            <Button
              darkMode={darkMode}
              label={"Save"}
              size={"sm"}
              variant={"primary"}
              onClick={saveAssetInfo}
              disabled={stockNumberValue.length == 0 && machineNumberValue.length == 0}
            />
          </div>
          :
          <div className="edit-btn">
            <Button
              darkMode={darkMode}
              label={"Edit Asset Info"}
              size={"sm"}
              variant={"secondary"}
              disabled={isDisabled || isGuest}
              onClick={toggleIsEditing}
            />
          </div>
        }
      </div>
    </div>
  );
};
